export default {
    hostDefault: 'http://localhost',    // 192.168.49.131 remote debug 
    portDefault: 8088,
    pathnameDefault: '',
    hostServer: 'https://comin.co',
    portServer: 443,
    pathnameServer: '/system/api',
    GoogleLocal: '960245280639-apkq5ilofburuimjtte66313b9r41a44.apps.googleusercontent.com',
    FbLocal: '761774717317607',
    GoogleServer: '411442044791-mb9t9htj1sqs26ev7470kpidv3kmsc5k.apps.googleusercontent.com',
    //FbServer: '495884620782080',
    FbServer: '333671397141927',
    TIMEOUT_RETRY: 10000,
    TIMEOUT_QUEUE: 2000,
    COUNT_RETRY: 10,
    ORDER_EXPIRED: 2419200
}